var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"col-form-label"},[_vm._v(_vm._s(_vm.getSnippet(_vm.field.label)))])
}
var staticRenderFns = []

export { render, staticRenderFns }